/* eslint-disable valid-jsdoc */
/**
 *  素材库公共数据服务
 */
angular.module('resourceCenterMaterialModule').service('mrApiService', [
    'trsHttpService',
    '$q',
    function (trsHttpService, $q) {
        let httpServer = trsHttpService.httpServerForMR;
        let resourceTypeForTextMaterial = '3';

        return {
            getMaterialData: getMaterialData, // 从海贝检索媒资素材
            getFolderMaterialData: getFolderMaterialData, // 获取文件夹内的素材
            getMaterialIndexData: getMaterialIndexData, // 从Mysql直接获取素材
            resetSearchparams: resetSearchparams, // 获取素材检索参数
            deleteMaterial: deleteMaterial, // 删除素材
            moveMaterialToFolder: moveMaterialToFolder, // 将素材移动到文件夹内
            createMateralFolder: createMateralFolder, // 穿件素材文件夹
            moveToSharedMaterial: moveToSharedMaterial, // 上传到共享素材
            moveToMaterialLibary: moveToMaterialLibary, // 上传到媒资库
            moveToPersonalMaterial: moveToPersonalMaterial, // 取至个人素材
            updateMaterial: updateMaterial, // 更新素材信息
            getMaterialDetail: getMaterialDetail, // 获取素材详情
            takeDoc: takeDoc, // 素材取稿到采编
            getTakeRecords: getTakeRecords, // 获取素材取签记录
            uploadMaterial: uploadMaterial, // 上传素材
            uploadByUrl: uploadByUrl, // 提交文件上传后的URL
            uploadCover: uploadCover, // 上传素材封面图
            downLoadMetrial: downLoadMetrial, // 下载素材
            getMark: getMark, // 获取标签
            getThemeData: getThemeData, // 获取主题数据
            getErrorMsg: getErrorMsg, // 获取机审失败的原因
            getAllFolders: getAllFolders, // 获取所有素材文件夹列表
            qEditMessage: qEditMessage, // 获取视频快编地址
            videoSplit: videoSplit, // 获取视频拆条地址
            addToPersonel: addToPersonel, // 添加到个人素材
            searchByPic: searchByPic, // 以图搜图
            rename: rename, // 素材和文件夹重命名
            resetIndexParams: resetIndexParams, // 获取首页数据（mysql）搜索参数
            resetFolderParams: resetFolderParams, // 获取文件夹关联素材检索参数
            requestCensor: requestCensor, // 智能机审地址
            ignoreError: ignoreError, // 忽略机审问题
            getExifInfo: getExifInfo, // 获取图片exif信息
            isCheckCensorOpen: isCheckCensorOpen // 判断三鉴是否开启
        };


        /**
         * [getMaterialData 获取素材列表数据]
         *
         * @param   {[type]}  params  [params description]
         *      params:{
         *
         *   isOriginal	integer($int32)
         *   是否原创
         *
         *   mark	string
         *   标签
         *
         *  resourceBitRate	string
         *    素材码率
         *
         *   resourceDuration	integer($int64)
         *    素材时长
         *
         *    resourceHeight	integer($int32)
         *    素材 高
         *
         *    resourceSize	string
         *    素材大小
         *
         *    resourceStatus	integer($int32)
         *    当前状态
         *
         *    resourceType	integer($int32)
         *    素材类型
         *
         *    resourceWidth	integer($int32)
         *    素材 长
         *
         *    saveTime	string
         *    素材创建时间
         *
         *    section	string
         *    素材创建时间
         *
         *    sourceType	string
         *    素材创建时间
         *
         *    zyzxfield	string
         *    分类信息
         *
         *        }
         * @return  {[type]}          [return description]
         */
        function getMaterialData(params, isFromEditingCenter) {
            let isEditingCenter = isFromEditingCenter || false;
            if (params.mainResourceType === resourceTypeForTextMaterial) {
                let deffered = $q.defer();
                textMaterialgetData(params).then(
                    function (data) {
                        if (isEditingCenter) {
                            deffered.resolve(data);
                        } else {
                            let newData = dealTextMaterialData(data);
                            deffered.resolve(newData);
                        }
                    },
                    function (data) {
                        deffered.reject(data);
                    }
                );

                return deffered.promise;
            } else {
                let requestParams = {};
                let action = 'resourceSearch';
                requestParams.url = getRequestUrl(params, action);
                requestParams.method = 'post';
                requestParams.contentType = 'application/json';
                let requestData = getRequestData(params, 'json');
                return sendRequest(requestParams, requestData);
            }
        }

        /**
         * [getMaterialData 获取文件夹内的素材]
         *
         * @param   {[type]}  params  [params description]
         *
         * @return  {[type]}          [return description]
         */
        function getFolderMaterialData(params) {
            if (params.mainResourceType === resourceTypeForTextMaterial) {
                let deffered = $q.defer();
                textMaterialgetData(params).then(
                    function (data) {
                        let newData = dealTextMaterialData(data);
                        deffered.resolve(newData);
                    },
                    function (data) {
                        deffered.reject(data);
                    }
                );

                return deffered.promise;
            } else {
                let requestParams = {};
                let action = 'folderSearch';
                requestParams.url = getRequestUrl(params, action);
                requestParams.method = 'get';
                requestParams.contentType = 'application/json';
                let requestData = getRequestData(params, 'query');
                requestParams.url += requestData;
                requestData = '';
                return sendRequest(requestParams, requestData);
            }
        }

        /**
         * [getMaterialIndexData 获取首页数据]
         *
         * @param   {[type]}  params  [params description]
         *
         * @return  {[type]}          [return description]
         */
        function getMaterialIndexData(params) {
            if (params.mainResourceType === resourceTypeForTextMaterial) {
                let deffered = $q.defer();
                textMaterialgetData(params).then(
                    function (data) {
                        let newData = dealTextMaterialData(data);
                        deffered.resolve(newData);
                    },
                    function (data) {
                        deffered.reject(data);
                    }
                );
                return deffered.promise;
            } else {
                let requestParams = {};
                let action = 'directSearch';
                requestParams.url = getRequestUrl(params, action);
                requestParams.method = 'get';
                requestParams.contentType = 'application/x-www-form-urlencoded;charset=UTF-8';
                let requestData = getRequestData(params, 'query');
                return sendRequest(requestParams, requestData);
            }
        }

        /**
         * [resetSearchparams 初始化检索参数]
         *
         * @return  {[type]}  [return description]
         */
        function resetSearchparams() {
            return {
                checkStatus: '', // 审核状态
                customEndTime: '', // 自定义时间的结束时间
                customStartTime: '', // 自定义时间的开始时间
                isOriginal: '', // 是否原创
                mark: '', // 标签,多个值时使用英文半角分号分隔
                name: '', // 名称，关键词搜索
                pictureSize: '', // 图片尺寸
                pictureType: '', // 图片横竖
                resourceBitRate: '', // 素材(视频)码率
                resourceDuration: '', // 素材(音视频)时长(单位秒),取值方式参照示例
                sourceType: '', // 媒资库中素材的来源
                zyzxField: '', // 分类信息
                pageSize: 8,
                pageNum: 1,
                sortBy: 'time',
                sortOrder: 'desc',
                fileId: 0,
            };
        }

        /**
         * [getRequestData 获取请求数据]
         *
         * @param   {[type]}  params  [params description]
         * @param   {[type]}  type    [type description]
         *
         * @return  {[type]}          [return description]
         */
        function getRequestData(params, type) {
            let data = angular.copy(params);
            delete data.mrType;
            delete data.mainResourceType;
            if (type === 'json') {
                return JSON.stringify(data);
            } else if (type === 'query') {
                let result = '';
                for (let key in data) {
                    result += '&' + key + '=' + data[key];
                }
                return result;
            }
            return data;
        }

        /**
         * [sendRequest 发送请求]
         *
         * @param   {[type]}  requestParams  [requestParams description]
         * @param   {[type]}  requestData    [requestData description]
         *
         * @return  {[type]}                 [return description]
         */
        function sendRequest(requestParams, requestData, isArrayBuffer) {
            let deffered = $q.defer();
            httpServer(requestParams, requestData, isArrayBuffer).then(
                function (data) {
                    deffered.resolve(data);
                },
                function (data) {
                    deffered.reject(data);
                }
            );
            return deffered.promise;
        }

        /**
         * [getRequestUrl 全部参数url拼接](顺序一定要正确)
         *
         * @param   {[type]}  params  [params description]
         * @param   {[type]}  actionType  [params description]
         *
         * @return  {[type]}          [return description]
         */
        function urlAllLine(params, actionType) {
            let data = angular.copy(params);
            delete data.relationId;
            let url = trsHttpService.getMRURL();
            Object.keys(data).forEach((key) => {
                url = url + '/' + params[key];
            });
            return url + '/' + actionType + '?';
        }

        /**
         * [getRequestUrl 获取请求URL]
         *
         * @param   {[type]}  params  [params description]
         * @param   {[type]}  actionType  [params description]
         *
         * @return  {[type]}          [return description]
         */
        function getRequestUrl(params, actionType) {
            let mrType = params.mrType;
            let resourceType = params.mainResourceType;
            let action = actionType || '';
            let urlSend = '?';
            if (params.relationId) {
                urlSend += `&relationId=${params.relationId}`;
                delete params.relationId;
            }
            if (angular.isDefined(params.pageNum)) {
                urlSend += `&pageNum=${params.pageNum}`;
                delete params.pageNum;
            }
            if (angular.isDefined(params.pageSize)) {
                urlSend += `&pageSize=${params.pageSize}`;
                delete params.pageSize;
            }
            if (angular.isDefined(params.sortBy)) {
                urlSend += `&sortBy=${params.sortBy}`;
                delete params.sortBy;
            }
            if (angular.isDefined(params.sortOrder)) {
                urlSend += `&sortOrder=${params.sortOrder}`;
                delete params.sortOrder;
            }
            mrType = mrType ? '/' + mrType : '';
            resourceType = resourceType ? '/' + resourceType : '';
            return trsHttpService.getMRURL() + mrType + resourceType + '/' + action + urlSend;
        }

        /**
         * [deleteMaterial 删除素材---？是否可以删除文件夹和图集]
         *
         * @param   {[type]}  params  [params description]
         *
         * @return  {[type]}          [return description]
         */
        function deleteMaterial(params) {
            if (params.mainResourceType === resourceTypeForTextMaterial) {
                let deffered = $q.defer();
                textMaterialdelete(params).then(
                    function (data) {
                        let newData = dealTextMaterialData(data);
                        deffered.resolve(newData);
                    },
                    function (data) {
                        deffered.reject(data);
                    }
                );
                return deffered.promise;
            } else {
                let requestParams = {};
                let action = 'delete';
                requestParams.url = getRequestUrl(params, action);
                requestParams.method = 'post';
                requestParams.contentType = 'application/x-www-form-urlencoded;charset=UTF-8';
                let requestData = getRequestData(params, 'query');
                return sendRequest(requestParams, requestData);
            }
        }

        /**
         * [moveMaterialToFolder 移动素材到文件夹内]
         *
         * @param   {[object]}  params  [params description] 移动素材到文件夹
         * @return  {promise}           [return description]
         */
        function moveMaterialToFolder(params) {
            if (params.mainResourceType === resourceTypeForTextMaterial) {
                let deffered = $q.defer();
                textMaterialMoveToFolder(params).then(
                    function (data) {
                        let newData = dealTextMaterialData(data);
                        deffered.resolve(newData);
                    },
                    function (data) {
                        deffered.reject(data);
                    }
                );
                return deffered.promise;
            } else {
                let requestParams = {};
                let action = 'move';
                requestParams.url = getRequestUrl(params, action);
                requestParams.method = 'post';
                requestParams.contentType = 'application/x-www-form-urlencoded;charset=UTF-8';
                let requestData = getRequestData(params, 'formdata');
                return sendRequest(requestParams, requestData);
            }
        }

        /**
         * [createMateralFolder 创建文件夹]
         *
         * @param   {[type]}  params  [params description]
         *
         * @return  {[type]}          [return description]
         */
        function createMateralFolder(params) {
            if (params.mainResourceType === resourceTypeForTextMaterial) {
                let deffered = $q.defer();
                textMaterialAddFolder(params).then(
                    function (data) {
                        let bigdata = dealTextMaterialData(data);
                        deffered.resolve(bigdata);
                    },
                    function (data) {
                        deffered.reject(data);
                    }
                );
                return deffered.promise;
            } else {
                let requestParams = {};
                let action = 'newDir';
                requestParams.url = getRequestUrl(params, action);
                requestParams.method = 'post';
                requestParams.contentType = 'text/plain;charset=UTF-8';
                let requestData = getRequestData(params, 'query');
                requestParams.url += requestData;
                requestData = '';
                return sendRequest(requestParams, requestData);
            }
        }

        /**
         * [moveToSharedMaterial 上传素材到共享素材]
         *
         * @param   {[type]}  params  [params description]
         *
         * @return  {[type]}          [return description]
         */
        function moveToSharedMaterial(params) {
            let requestParams = {};
            let action = 'share';
            requestParams.url = getRequestUrl(params, action);
            requestParams.method = 'get';
            requestParams.contentType = 'text/plain;charset=UTF-8';
            let requestData = getRequestData(params, 'query');
            requestParams.url += requestData;
            requestData = '';
            return sendRequest(requestParams, requestData);
        }

        /**
         * [moveToMaterialLibary 上传素材到媒资库]
         *
         * @param   {[type]}  params  [params description]
         *
         * @return  {[type]}          [return description]
         */
        function moveToMaterialLibary(params) {
            let requestParams = {};
            let action = 'toMeizi';
            requestParams.url = getRequestUrl(params, action);
            requestParams.method = 'get';
            requestParams.contentType = 'application/x-www-form-urlencoded;charset=UTF-8';
            let requestData = getRequestData(params, 'query');
            requestParams.url += requestData;
            requestData = '';
            return sendRequest(requestParams, requestData);
        }

        /**
         * [moveToPersonalMaterial 将素材取至个人素材]
         *
         * @param   {[type]}  params  [params description]
         *
         * @return  {[type]}          [return description]
         */
        function moveToPersonalMaterial(params) {
            let requestParams = {};
            let action = 'toPerson';
            requestParams.url = getRequestUrl(params, action);
            requestParams.method = 'get';
            requestParams.contentType = 'text/plain;charset=UTF-8';
            let requestData = getRequestData(params, 'query');
            requestParams.url += requestData;
            requestData = '';
            return sendRequest(requestParams, requestData);
        }

        /**
         * [updateMaterial 更新素材信息]
         *
         * @param   {[type]}  params  [params description]
         *{
        eventMark	string
        事物标签

        original	integer($int32)
        原创标志

        personMark	string
        人物标签

        placeMark	string
        地域标签

        resourceTitle*	string
        标题

        zyzxfield	string
        分类

        }
        * @return  {[type]}          [return description]
        */
        function updateMaterial(params) {
            let requestParams = {};
            let action = 'update';
            requestParams.url = getRequestUrl(params, action);
            requestParams.method = 'post';
            requestParams.contentType = 'application/json';
            let requestData = getRequestData(params, 'json');
            return sendRequest(requestParams, requestData);
        }

        /**
         * [getMaterialDetail 获取素材细览信息]
         *
         * @param   {[type]}  params  [params description]
         *
         * @return  {[type]}          [return description]
         */
        function getMaterialDetail(params) {
            let requestParams = {};
            requestParams.url = getRequestUrl(params, 'detail');
            requestParams.method = 'get';
            requestParams.contentType = 'text/plain;charset=UTF-8';
            let requestData = getRequestData(params, 'query');
            requestParams.url += requestData;
            requestData = '';
            return sendRequest(requestParams, requestData);
        }

        /**
         * [takeDoc description]取稿操作
         *
         * @param   {[type]}  params  [params description]
         *
         * @return  {[type]}          [return description]
         */
        function takeDoc(params) {
            let requestParams = {};
            requestParams.url = getRequestUrl(params, 'fetch');
            requestParams.method = 'get';
            requestParams.contentType = 'text/plain;charset=UTF-8';
            let requestData = getRequestData(params, 'query');
            requestParams.url += requestData;
            requestData = '';
            return sendRequest(requestParams, requestData);
        }

        /**
         * 取签记录
         */
        function getTakeRecords(params) {
            let mrType = params.mrType;
            let resourceType = params.mainResourceType;
            let requestParams = {};
            requestParams.method = 'get';
            requestParams.contentType = 'text/plain;charset=UTF-8';
            mrType = mrType ? '/' + mrType : '';
            resourceType = resourceType ? '/' + resourceType : '';
            let urlSend = params.relationId + '/' + params.operation + '/fetchOrPublishInfo';
            requestParams.url = trsHttpService.getMRURL() + mrType + resourceType + '/' + urlSend;
            let requestData = '';
            return sendRequest(requestParams, requestData);
        }

        /**
         * [uploadMaterial 上传素材]
         *
         * @param   {[type]}  params  [params description]
         *
         * @return  {[type]}          [return description]
         */
        function uploadMaterial(params) {
            let requestParams = {};
            let action = 'move';
            requestParams.url = getRequestUrl(params, action);
            requestParams.method = 'post';
            requestParams.contentType = 'multipart/form-data;charset=UTF-8';
            let requestData = getRequestData(params, 'formdata');
            sendRequest(requestParams, requestData);
        }

        /**
         * [uploadMaterial 素材上传]
         *
         * @param   {[type]}  params  [params description]
         *
         * @return  {[type]}          [return description]
         */
        function uploadByUrl(params) {
            params.fileName = encodeURIComponent(params.fileName);
            let requestParams = {};
            let action = 'uploadByUrl';
            requestParams.url = getRequestUrl(params, action);
            requestParams.method = 'post';
            requestParams.contentType = 'application/x-www-form-urlencoded;charset=UTF-8';
            let requestData = getRequestData(params, 'query');
            return sendRequest(requestParams, requestData);
        }

        /**
         * [uploadCover 上传封面图]
         *
         * @param   {[type]}  params  [params description]
         *
         *     {[file]} multipartFile  封面图文件
         *
         * @return  {[type]}          [return description]
         */
        function uploadCover(params) {
            let requestParams = {};
            let action = '';
            requestParams.url = getRequestUrl(params, action);
            requestParams.method = 'post';
            requestParams.contentType = 'multipart/form-data;charset=UTF-8';
            let requestData = getRequestData(params, 'formdata');
            sendRequest(requestParams, requestData);
        }

        /**
         * [downLoadMetrial description]素材下载操作
         *
         * @return  {[type]}  [return description]
         */
        function downLoadMetrial(params) {
            let requestParams = {};
            requestParams.url = getRequestUrl(params, 'download');
            requestParams.method = 'get';
            requestParams.contentType = 'text/plain;charset=UTF-8';
            let requestData = getRequestData(params, 'query');
            requestParams.url += requestData;
            requestData = '';
            return sendRequest(requestParams, requestData, true);
        }

        /**
         * [getMark 获取标签]
         *
         * @param   {[type]}  params  [params description]
         *
         * @return  {[type]}          [return description]
         */
        function getMark(params){
            let requestParams = {};
            let action = 'markSearch';
            requestParams.url = getRequestUrl(params, action);
            requestParams.method = 'get';
            requestParams.contentType = 'application/x-www-form-urlencoded;charset=UTF-8';
            let requestData = getRequestData(params, 'query');
            requestParams.url += requestData;
            requestData = '';
            return sendRequest(requestParams, requestData);
        }

        /**
         * [getThemeData description] 获取主题分类数据
         * @return  {[type]}  [return description]
         */
        function getThemeData() {
            var defer = $q.defer();
            var themeParams = {
                serviceid: 'navigation',
                typeid: 'zyzx',
                modelid: 'base',
                parentId: '-1',
                level: '2',
                excludeId: '-1',
                containParent: false,
                channelName: 'app',
                typeName: 'zyzxfield',
            };
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), themeParams, 'post').then(function (themeData) {
                defer.resolve(themeData);
            });
            return defer.promise;
        }

        /**
         * [getErrorMsg 获取审核不通过的原因]
         *
         * @param   {[type]}  params  [params description]
         *
         * @return  {[type]}          [return description]
         */
        function getErrorMsg(params) {
            let requestParams = {};
            requestParams.url = getRequestUrl(params, 'error_info');
            requestParams.method = 'get';
            requestParams.contentType = 'application/json';
            let requestData = getRequestData(params, 'query');
            requestParams.url += requestData;
            requestData = '';
            return sendRequest(requestParams, requestData);
        }

        /**
         * [folderSearch description] 文件夹集合查询
         * @param   {[type]}  params  [params description] 请求参数
         * @return  {[type]}          [return description]
         */
        function getAllFolders(params) {
            if (params.mainResourceType === resourceTypeForTextMaterial) {
                let deffered = $q.defer();
                textMaterialgetFolder(params).then(
                    function (data) {
                        let bigdata = dealTextMaterialData(data);
                        deffered.resolve(bigdata);
                    },
                    function (data) {
                        deffered.reject(data);
                    }
                );
                return deffered.promise;
            } else {
                let requestParams = {};
                let action = 'getAllFolders';
                requestParams.url = getRequestUrl(params, action);
                requestParams.method = 'get';
                requestParams.contentType = 'application/x-www-form-urlencoded;charset=UTF-8';
                let requestData = getRequestData(params, 'formdata');
                return sendRequest(requestParams, requestData);
            }
        }


        /**
         * [folderSearch description] 快编查询
         * @param   {[type]}  params  [params description] 请求参数
         * @return  {[type]}          [return description]
         */
        function qEditMessage(params) {
            let requestParams = {};
            let action = 'qEdit';
            requestParams.url = urlAllLine(params, action);
            requestParams.method = 'get';
            requestParams.contentType = 'application/x-www-form-urlencoded;charset=UTF-8';
            let requestData = getRequestData(params, 'query');
            requestParams.url += requestData;
            requestData = '';
            return sendRequest(requestParams, requestData);
        }

        /**
         * [folderSearch description] 拆条查询
         * @param   {[type]}  params  [params description] 请求参数
         * @return  {[type]}          [return description]
         */
        function videoSplit(params) {
            let requestParams = {};
            let action = 'chaitiao';
            requestParams.url = urlAllLine(params, action);
            requestParams.method = 'get';
            requestParams.contentType = 'application/x-www-form-urlencoded;charset=UTF-8';
            let requestData = getRequestData(params, 'query');
            requestParams.url += requestData;
            requestData = '';
            return sendRequest(requestParams, requestData);
        }

        /**
         * [textMaterialgetData 获取文字素材数据]
         *
         * @param   {[type]}  param  [param description]
         *
         * @return  {[type]}         [return description]
         */
        function textMaterialgetData(param) {
            let params = {
                mrType: 'mlf_releaseSource',
                mainResourceType: 'queryPersonalMaterials',
                CurrPage: param.pageNum,
                PageSize: param.pageSize,
                PersonalMaterialId: param.relationId || 0,
                fileType: 1,
                order: param.sortBy === 'time' ? 0 : 1,
                // 对搜索关键词进行编码 否则会报参数不合法错误
                searchValue: param.name ? encodeURIComponent(param.name) : '',
                status: 0,
            };
            if (angular.isDefined(param.isPureMaterial)) {
                params.IsExcludeFolder = param.isPureMaterial !== 0;
            }
            return textMaterialServie(params);
        }

        /**
         * [textMaterialAddFolder 文字素材新建文件夹]
         *
         * @param   {[type]}  param  [param description]
         *
         * @return  {[type]}         [return description]
         */
        function textMaterialAddFolder(param) {
            let params = {
                mrType: 'mlf_releaseSource',
                mainResourceType: 'addFolder',
                PersonalMaterialId: 0,
                fileName: param.fileName,
            };
            return textMaterialServie(params);
        }

        /**
         * [textMaterialdelete 文字素材删除]
         *
         * @param   {[type]}  param  [param description]
         *
         * @return  {[type]}         [return description]
         */
        function textMaterialdelete(param) {
            let params = {
                mrType: 'mlf_releaseSource',
                mainResourceType: 'delFiles',
                PersonalMaterialIds: param.relationIds,
            };
            return textMaterialServie(params);
        }

        /**
         * [textMaterialgetFolder 获取文字素材文件夹列表]
         *
         * @param   {[type]}  param  [param description]
         *
         * @return  {[type]}         [return description]
         */
        function textMaterialgetFolder(param) {
            let params = {
                mrType: 'mlf_releaseSource',
                mainResourceType: 'queryChildernFolder',
                PersonalMaterialId: 0,
            };
            return textMaterialServie(params);
        }

        /**
         * [textMaterialreFilename 文字素材重命名]
         *
         * @param   {[type]}  param  [param description]
         *
         * @return  {[type]}         [return description]
         */
        function textMaterialreFilename(param) {
            let params = {
                mrType: 'mlf_releaseSource',
                mainResourceType: 'reNameFile',
                fileDesc: param.fileName,
                PersonalMaterialId: param.id
            };
            return textMaterialServie(params);
        }

        /**
         * [textMaterialMoveToFolder 将文字素材移动到文件夹]
         *
         * @param   {[type]}  param  [param description]
         *
         * @return  {[type]}         [return description]
         */
        function textMaterialMoveToFolder(param) {
            let params = {
                mrType: 'mlf_releaseSource',
                mainResourceType: 'moveFile',
                toPersonalMaterialId: param.fileId,
                fromPersonalMaterialIds: param.relationIds,
            };
            return textMaterialServie(params);
        }

        /**
         * [textMaterialServie 文字素材统一请求处理]
         *
         * @param   {[type]}  params  [params description]
         *
         * @return  {[type]}          [return description]
         */
        function textMaterialServie(params) {
            let requestParams = {};
            let action = 'character';
            requestParams.url = getRequestUrl(params, action);
            requestParams.method = 'get';
            requestParams.contentType = 'application/x-www-form-urlencoded;charset=UTF-8';
            let requestData = getRequestData(params, 'query');
            requestParams.url += requestData;
            requestData = '';
            return sendRequest(requestParams, requestData);
        }

        /**
         * [textMaterialServie 文字素材数据适配]
         *
         * @param   {[type]}  data  [data description]
         *
         * @return  {[type]}          [return description]
         */
        function dealTextMaterialData(data) {
            if (data.datas.length) {
                data.datas.forEach(function (element, index) {
                    let tmp = {
                        relationid: element.personalmaterialid,
                        resourcetitle: element.filedesc,
                        resourcetype: 3,
                        savetime: element.crtime,
                        relationtype: element.filetype === '0' ? 0 : 2,
                        resourcestatus: element.status === '0' ? 1 : 1,
                        mrtype: 'personal',
                        content: element.htmlcontent || element.content || '',
                    };
                    data.datas[index] = tmp;
                });
            }
            return data;
        }

        /**
         * [addToPersonel description]添加到媒资库个人素材
         *
         * @param   {[type]}  params  [params description]
         *
         * @return  {[type]}          [return description]
         */
        function addToPersonel(params) {
            let requestParams = {};
            requestParams.url = getRequestUrl(params, 'add');
            requestParams.method = 'post';
            requestParams.contentType = 'application/x-www-form-urlencoded;charset=UTF-8';
            let requestData = getRequestData(params, 'form');
            // requestParams.url += requestData;
            // requestData = '';
            return sendRequest(requestParams, requestData);
        }


        /**
         * [searchByPic 以图搜图]
         *
         * @param   {[type]}  params  [params description]
         *
         * @return  {[type]}          [return description]
         */
        function searchByPic(params) {
            let action = 'imgSearchImgs';
            let requestParams = {};
            requestParams.url = trsHttpService.getMRURL() + '/meizi/image/' + action;
            requestParams.method = 'post';
            requestParams.contentType = undefined;
            requestParams.transformRequest = function (data) {
                var formData = new FormData();
                for (var a in data) {
                    formData.append(a, data[a]);
                }
                return formData;
            };
            return sendRequest(requestParams, params);
        }

        /**
         * [uploadMaterial 素材重命名]
         *
         * @param   {[type]}  params  [params description]
         *
         * @return  {[type]}          [return description]
         */
        function rename(params) {
            if (params.mainResourceType === resourceTypeForTextMaterial) {
                let deffered = $q.defer();
                textMaterialreFilename(params).then(
                    function (data) {
                        let bigdata = dealTextMaterialData(data);
                        deffered.resolve(bigdata);
                    },
                    function (data) {
                        deffered.reject(data);
                    }
                );
                return deffered.promise;
            } else {
                let requestParams = {};
                let action = 'renameFile';
                requestParams.url = getRequestUrl(params, action);
                requestParams.method = 'post';
                requestParams.contentType = 'application/x-www-form-urlencoded;charset=UTF-8';
                let requestData = getRequestData(params, 'query');
                return sendRequest(requestParams, requestData);
            }
        }

        /**
         * [resetIndexParams 初始化mysql搜索参数]
         *
         * @return  {[type]}  [return description]
         */
        function resetIndexParams(){
            return {
                pageSize: 8,
                pageNum: 1,
                sortBy: 'time',
                sortOrder: 'desc',
            };
        }

        /**
         * [resetFolderParams 获取文件夹关联素材检索参数]
         *
         * @return  {[type]}  [return description]
         */
        function resetFolderParams(){
            return {
                pageSize: 8,
                pageNum: 1,
                relationId: 0,
                sortBy: 'time',
                sortOrder: 'desc',
            };
        }

        /**
         * [requestCensor 手动智能机审]
         *
         * @return  {[type]}  [return description]
         */
        function requestCensor(params){
            params.relationIds = params.relationId;
            delete params.relationId;
            let action = 'censor';
            let requestParams = {};
            requestParams.url = getRequestUrl(params, action);
            requestParams.method = 'post';
            requestParams.contentType = 'application/x-www-form-urlencoded;charset=UTF-8';
            let requestData = getRequestData(params, 'query');
            requestParams.url += requestData;
            requestData = '';
            return sendRequest(requestParams, requestData);
        }

        /**
         * [requestCensor 忽略机审问题]
         *
         * @return  {[type]}  [return description]
         */
        function ignoreError(params){
            let action = 'ignore';
            let requestParams = {};
            requestParams.url = getRequestUrl(params, action);
            requestParams.method = 'post';
            requestParams.contentType = 'application/x-www-form-urlencoded;charset=UTF-8';
            let requestData = getRequestData(params, 'query');
            requestParams.url += requestData;
            requestData = '';
            return sendRequest(requestParams, requestData);
        }
        
        /**
         * [getExifInfo description] 根据图片自动获取图片信息，并自动填入
         *
         * @param  {[type]}  file   [file description]
         * @param  {[type]}  item   [item description]
         *
         * @return  {[type]}   [return description]
         */
        function getExifInfo(file, item) {
            EXIF.getData(file, function () {
                const exifData = EXIF.pretty(this);
                if (exifData) {
                    var timeArray = EXIF.getTag(this, 'DateTimeOriginal').split(' ');
                    timeArray[0] = timeArray[0].split(':').join('-');
                    item.filmingtime = timeArray.join(' ');
                    item.filminglocation = EXIF.getTag(this, 'location');
                }
            });
        }

        /**
         * [isCheckCensorOpen 判断三鉴是否开启]
         *
         * @param   {[type]}  params  [params description]
         *
         * @return  {[type]}          [return description]
         */
        function isCheckCensorOpen() {
            let requestParams = {};
            requestParams.url = trsHttpService.getMRURL() + '/common/checkCensorOpenStatus';
            requestParams.method = 'get';
            let requestData = '';
            return sendRequest(requestParams, requestData);
        }
    },
]);
